import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Necesito saber inglés?',
  a: 'No, la IA entiende y responde perfectamente en español.'
}, {
  q: '¿Tengo que pagar por las herramientas?',
  a: 'No, te enseñamos a usar las versiones gratuitas más potentes.'
}, {
  q: '¿Es seguro para los niños?',
  a: 'El libro incluye un capítulo entero sobre privacidad y límites éticos.'
}, {
  q: '¿Sirve para niños de primaria y secundaria?',
  a: 'Sí, las dinámicas están adaptadas para ambos niveles.'
}, {
  q: '¿El material es físico?',
  a: 'Es un producto digital descargable (PDF) para acceso inmediato.'
}, {
  q: '¿Cuánto tiempo me tomará aprender?',
  a: 'La guía está diseñada para darte resultados desde la primera página.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-13">
      <div className="max-w-3xl mx-auto" data-id="element-14">
        <div className="text-center mb-12" data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-16">
            Preguntas Frecuentes
          </h2>
          <p className="text-lg text-brand-text" data-id="element-17">
            Resolvemos tus dudas antes de empezar.
          </p>
        </div>

        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <div key={index} className="border border-cream-200 rounded-2xl overflow-hidden bg-cream-50/50" data-id="element-19">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-20">
                <span className="font-bold text-brand-dark pr-4" data-id="element-21">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="text-brand-blue shrink-0" data-id="element-22">
                  <ChevronDown size={20} data-id="element-23" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-24">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-25">
                    <div className="px-6 pb-5 text-brand-text border-t border-cream-100 pt-3" data-id="element-26">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}